import { jsxs as n, jsx as o } from "react/jsx-runtime";
import { forwardRef as a } from "react";
const t = ({
  title: e,
  titleId: r,
  ...i
}, l) => /* @__PURE__ */ n("svg", { viewBox: "0 0 24 24", width: "1.2em", height: "1.2em", ref: l, "aria-labelledby": r, ...i, children: [
  e ? /* @__PURE__ */ o("title", { id: r, children: e }) : null,
  /* @__PURE__ */ o("path", { fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497zM15 5l4 4" })
] }), c = a(t);
export {
  c as default
};
//# sourceMappingURL=pencil.js.map
